import { vars } from '../../theme';
import React from 'react';
import HBBannerBase from '../HBBanner/HBBannerBase';
import { Bell24 } from '@honeybook/icons';
import type { buttonThemes } from '../HBButton/HBButton.styles';
import { HBBannerProps, TBannerActionTheme } from '../HBBanner/HBBanner.types';
import { MustIncludeOneOfBasicTestIdProps } from '../common/internal/test-id.types';

type TBannersActionTheme = 'primary' | 'secondary' | 'button-link';
export interface Props extends HBBannerProps {
    /** Button style for actions: 'primary' and 'secondary' render filled buttons, 'button-link' renders as a link (incompatible with secondaryAction). Defaults to 'primary'. */
    actionsTheme?: TBannersActionTheme;
}

const actionThemeToButtonTheme = (
    whiteBanner: boolean
): Record<TBannerActionTheme, keyof typeof buttonThemes> => ({
    primary: whiteBanner ? 'primary' : 'primary-blue',
    secondary: 'secondary-solid-secondary',
    'button-link': 'button-link-blue'
});

const InfoBanner = ({
    whiteBanner,
    actionsTheme = 'primary',
    ...props
}: Props & MustIncludeOneOfBasicTestIdProps) => {
    return (
        <HBBannerBase
            icon={Bell24}
            {...props}
            actionsTheme={actionsTheme}
            accentLine={vars.colors.base.accent}
            background={vars.colors.surface.accent}
            whiteBanner={whiteBanner}
            primaryActionTheme={
                actionThemeToButtonTheme(whiteBanner)[actionsTheme]
            }
        />
    );
};

export default InfoBanner;
